import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ClientInteractionService extends Service {
	constructor(injector: Injector) {
		super("ClientInteraction", injector);
	}

	// API
	getInteractionsByClient(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetInteractionsByClientId/${id}`);
	}
}